import API_BASE from "../config/api";


export const confirmCustomerLedgerBalance = async (payload) => {
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Customer/ConfirmLedgerBalance`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to confirm ledger balance");
  }

  return await response.json();
};